//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_piOverThree = 1.0471975511965976;\n\
";
